import { useAppState } from "contexts/UserContext";
import { useAuth } from "contexts/AuthContext";
import { useCause } from "contexts/CauseContext";
import { useTeam } from "contexts/TeamContext";
import { useSubscription } from "../../../contexts/SubscriptionContext";

export const useSettingsContextData = () => {
  const { setMoods, isLoading, refreshData } = useAppState();
  const { setCauseTypes } = useCause();
  const { organizationId, setOrganizationId } = useTeam();
  const { userId, email, logout } = useAuth();
  const { isSubscribed, products } = useSubscription();

  return {
    setMoods,
    isLoading,
    refreshData,
    setCauseTypes,
    organizationId,
    setOrganizationId,
    userId,
    email,
    logout,
    isSubscribed,
  };
};
